
import { useState } from "react";
import { toast } from "sonner";
import { validateEmailForm } from "@/utils/email/emailValidation";
import { sendEmail } from "@/utils/email/emailSenderService";
import type { EmailFormData } from "@/utils/email/emailTemplates";

export const useEmailSender = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSendEmail = async (formData: EmailFormData) => {
    setIsSubmitting(true);
    console.log('Starting email sending process...');
    
    // Basic validation
    const validation = validateEmailForm(formData.name, formData.email);
    if (!validation.isValid) {
      toast.error(validation.errorTitle || "Error", {
        description: validation.errorMessage,
      });
      setIsSubmitting(false);
      return false;
    }
    
    // Validate message is not empty
    if (!formData.message?.trim()) {
      toast.error("Campo requerido", {
        description: "Por favor ingrese un mensaje."
      });
      setIsSubmitting(false);
      return false;
    }
    
    try {
      // Trim and clean form data before sending
      const cleanedFormData = {
        name: formData.name.trim(),
        email: formData.email.trim(),
        phone: formData.phone.trim(),
        message: formData.message.trim()
      };
      
      const success = await sendEmail(cleanedFormData);
      return success;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { sendEmail: handleSendEmail, isSubmitting };
};
